{
  "login.meta.title": {
    "translation": "Giriş Yap — {{brandName}} Geliştirici"
  },
  "login.meta.description": {
    "translation": "{{brandName}} Geliştirici hesabınıza giriş yapın"
  },
  "login.heading": {
    "translation": "{{brandName}} Geliştirici"
  },
  "login.subtitle": {
    "translation": "Restoran POS Entegrasyon Merkezi"
  },
  "nav.brand.label": {
    "translation": "{{brandName}} Geliştirici"
  },
  "login.email.label": {
    "translation": "İş E-postası"
  },
  "login.email.placeholder": {
    "translation": "siz@sirket.com"
  },
  "login.email.error.required": {
    "translation": "E-posta gereklidir."
  },
  "login.email.error.invalid": {
    "translation": "Geçerli bir e-posta adresi girin (örn. siz@sirket.com)."
  },
  "login.email.error.nonWork": {
    "translation": "Lütfen şirket iş e-postanızı kullanın."
  },
  "login.password.label": {
    "translation": "Şifre"
  },
  "login.password.placeholder": {
    "translation": "Şifrenizi girin"
  },
  "login.password.show": {
    "translation": "Şifreyi göster"
  },
  "login.password.hide": {
    "translation": "Şifreyi gizle"
  },
  "login.password.error.required": {
    "translation": "Şifre gereklidir."
  },
  "login.password.error.incorrect": {
    "translation": "Hatalı şifre. Tekrar deneyin veya sıfırlayın."
  },
  "login.submit": {
    "translation": "Giriş Yap"
  },
  "login.submitting": {
    "translation": "Giriş yapılıyor..."
  },
  "login.cta.register": {
    "translation": "API Erişimi İçin Başvur"
  },
  "login.cta.existingPartner": {
    "translation": "Entegre misiniz? Buradan kaydolun"
  },
  "login.cta.forgotPassword": {
    "translation": "Şifremi unuttum?"
  },
  "login.error.locked": {
    "translation": "Çok fazla başarısız deneme. Hesabınız 15 dakika boyunca kilitlendi."
  },
  "login.error.inactive": {
    "translation": "Bu hesap artık aktif değil. Yardım için destek ile iletişime geçin."
  },
  "login.error.notFound": {
    "translation": "Bu e-postayı tanıyamıyoruz. Yazım hatalarını kontrol edin veya erişim için başvurun."
  },
  "login.error.invalidCredentials": {
    "translation": "Hatalı e-posta veya şifre. Tekrar deneyin veya sıfırlayın."
  },
  "login.error.networkFailure": {
    "translation": "Giriş başarısız. Bağlantınızı kontrol edip tekrar deneyin."
  },
  "login.error.sessionExpired": {
    "translation": "Oturumunuzun süresi doldu. Lütfen tekrar giriş yapın."
  },
  "register.meta.title": {
    "translation": "API Erişimi İçin Başvur — {{brandName}} Geliştirici"
  },
  "register.meta.description": {
    "translation": "Delivery Hero POS sistemlerine API erişimi için başvurun."
  },
  "register.heading": {
    "translation": "API Erişimi İçin Başvur"
  },
  "register.subtitle": {
    "translation": "Şirketiniz ve faaliyet gösterdiğiniz pazarlar hakkında bilgi verin."
  },
  "register.markets.label": {
    "translation": "Pazarlar"
  },
  "register.markets.placeholder": {
    "translation": "Pazar seçin"
  },
  "register.markets.selected": {
    "translation": "{{count}} pazar seçildi"
  },
  "register.markets.search": {
    "translation": "Ülke ara"
  },
  "register.markets.editLabel": {
    "translation": "Pazar seçimini düzenle"
  },
  "register.markets.apply": {
    "translation": "Uygula"
  },
  "register.markets.error.required": {
    "translation": "En az bir pazar seçin."
  },
  "register.firstName.label": {
    "translation": "Ad"
  },
  "register.firstName.placeholder": {
    "translation": "Ayşe"
  },
  "register.firstName.error.required": {
    "translation": "Ad gereklidir."
  },
  "register.lastName.label": {
    "translation": "Soyad"
  },
  "register.lastName.placeholder": {
    "translation": "Yılmaz"
  },
  "register.lastName.error.required": {
    "translation": "Soyad gereklidir."
  },
  "register.email.label": {
    "translation": "İş E-postası"
  },
  "register.email.placeholder": {
    "translation": "siz@sirket.com"
  },
  "register.email.error.required": {
    "translation": "E-posta gereklidir."
  },
  "register.email.error.invalid": {
    "translation": "Geçerli bir e-posta adresi girin (örn. siz@sirket.com)."
  },
  "register.email.error.nonWork": {
    "translation": "Lütfen şirket iş e-postanızı kullanın."
  },
  "register.email.error.duplicate": {
    "translation": "Bu e-postayla zaten bir hesap var. Giriş yapmak ister misiniz?"
  },
  "register.phone.label": {
    "translation": "Telefon"
  },
  "register.phone.placeholder": {
    "translation": "+90 555 123 4567"
  },
  "register.phone.helper": {
    "translation": "Ülke kodunu ekleyin."
  },
  "register.phone.error.required": {
    "translation": "Telefon numarası gereklidir."
  },
  "register.company.label": {
    "translation": "Şirket Adı"
  },
  "register.company.placeholder": {
    "translation": "Acme Corp"
  },
  "register.company.error.required": {
    "translation": "Şirket adı gereklidir."
  },
  "register.website.label": {
    "translation": "Şirket Web Sitesi"
  },
  "register.website.placeholder": {
    "translation": "https://acme.com"
  },
  "register.website.error.required": {
    "translation": "Şirket web sitesi gereklidir."
  },
  "register.website.error.invalid": {
    "translation": "https:// ile başlayan geçerli bir URL girin (örn. https://acme.com)."
  },
  "register.vendors.label": {
    "translation": "Satıcı Sayısı"
  },
  "register.vendors.placeholder": {
    "translation": "Bir aralık seçin"
  },
  "register.vendors.options.1_10": {
    "translation": "1–10"
  },
  "register.vendors.options.11_50": {
    "translation": "11–50"
  },
  "register.vendors.options.51_200": {
    "translation": "51–200"
  },
  "register.vendors.options.200plus": {
    "translation": "200+"
  },
  "register.vendors.error.required": {
    "translation": "Yönettiğiniz satıcı sayısını seçin."
  },
  "register.pgpKey.label": {
    "translation": "PGP Genel Anahtarı"
  },
  "register.pgpKey.placeholder": {
    "translation": "-----BEGIN PGP PUBLIC KEY BLOCK-----"
  },
  "register.pgpKey.helper": {
    "translation": "PGP genel anahtarınız, API kimlik bilgilerinizi güvenli şekilde şifrelemek için kullanılır."
  },
  "register.pgpKey.error.required": {
    "translation": "PGP genel anahtarı gereklidir."
  },
  "register.terms.prefix": {
    "translation": "Kabul ediyorum: "
  },
  "register.terms.termsLink": {
    "translation": "Hüküm ve Koşullar"
  },
  "register.terms.separator": {
    "translation": " ve "
  },
  "register.terms.privacyLink": {
    "translation": "Gizlilik Politikası"
  },
  "register.terms.error.required": {
    "translation": "Devam etmek için Hüküm ve Koşulları kabul etmelisiniz."
  },
  "register.submit": {
    "translation": "Başvuruyu Gönder"
  },
  "register.submitting": {
    "translation": "Gönderiliyor..."
  },
  "register.error.submissionFailed": {
    "translation": "Başvurunuzu gönderirken bir hata oluştu. Lütfen tekrar deneyin."
  },
  "register.cta.backToLogin": {
    "translation": "Girişe Dön"
  },
  "register_confirm.meta.title": {
    "translation": "E-postanızı kontrol edin — {{brandName}} Geliştirici"
  },
  "register_confirm.meta.description": {
    "translation": "Size doğrulama e-postası gönderdik."
  },
  "register_confirm.heading": {
    "translation": "E-postanızı kontrol edin"
  },
  "register_confirm.message": {
    "translation": "<strong>{{email}}</strong> adresine doğrulama e-postası gönderdik. Hesabınızı doğrulamak ve şifrenizi belirlemek için bağlantıya tıklayın."
  },
  "register_confirm.cta.backToLogin": {
    "translation": "Girişe Dön"
  },
  "existing_partner.meta.title": {
    "translation": "Mevcut Ortak — {{brandName}} Geliştirici"
  },
  "existing_partner.meta.description": {
    "translation": "Mevcut bir Delivery Hero POS entegrasyon ortağı olarak kaydolun."
  },
  "existing_partner.heading": {
    "translation": "Entegre misiniz?"
  },
  "existing_partner.subtitle": {
    "translation": "Kayıtlı iş e-postanızı girin, size bir doğrulama bağlantısı gönderelim."
  },
  "existing_partner.email.label": {
    "translation": "İş E-postası"
  },
  "existing_partner.email.placeholder": {
    "translation": "siz@sirket.com"
  },
  "existing_partner.email.helper": {
    "translation": "Orijinal POS entegrasyonu sırasında kayıtlı olan e-posta adresini kullanın."
  },
  "existing_partner.email.error.required": {
    "translation": "E-posta gereklidir."
  },
  "existing_partner.email.error.invalid": {
    "translation": "Geçerli bir e-posta adresi girin (örn. siz@sirket.com)."
  },
  "existing_partner.email.error.notFound": {
    "translation": "Bu e-posta için eşleşme bulunamadı. Yazım hatalarını kontrol edin veya erişim için başvurun."
  },
  "existing_partner.email.error.inactive": {
    "translation": "Entegrasyonunuz şu anda aktif değil. Durumunuzu yeniden doğrularken portala bekleme modunda erişebilirsiniz."
  },
  "existing_partner.email.error.alreadySent": {
    "translation": "Doğrulama bağlantısı zaten gönderildi. Gelen kutunuzu kontrol edin veya yeni bağlantı istemeden önce bekleyin."
  },
  "existing_partner.submit": {
    "translation": "Hesabımı bul"
  },
  "existing_partner.submitting": {
    "translation": "Aranıyor..."
  },
  "existing_partner.success.sent": {
    "translation": "{{email}} adresine bir doğrulama bağlantısı gönderdik. Şifrenizi belirlemek için tıklayın."
  },
  "existing_partner.error.apiFailure": {
    "translation": "Bir şeyler ters gitti. Lütfen tekrar deneyin veya destek ile iletişime geçin."
  },
  "existing_partner.error.rateLimited": {
    "translation": "Çok fazla deneme yapıldı. Lütfen tekrar denemeden önce birkaç dakika bekleyin."
  },
  "existing_partner.cta.backToLogin": {
    "translation": "Girişe Dön"
  },
  "existing_partner.cta.returnToLogin": {
    "translation": "Girişe Dön"
  },
  "set_password.meta.title": {
    "translation": "Şifrenizi belirleyin — {{brandName}} Geliştirici"
  },
  "set_password.meta.description": {
    "translation": "{{brandName}} Geliştirici hesabınız için güvenli bir şifre oluşturun."
  },
  "set_password.heading": {
    "translation": "Şifrenizi belirleyin"
  },
  "set_password.subtitle": {
    "translation": "Hesabınıza erişmek için güvenli bir şifre oluşturun."
  },
  "set_password.password.label": {
    "translation": "Yeni Şifre"
  },
  "set_password.password.placeholder": {
    "translation": "Şifrenizi girin"
  },
  "set_password.password.show": {
    "translation": "Şifreyi göster"
  },
  "set_password.password.hide": {
    "translation": "Şifreyi gizle"
  },
  "set_password.password.error.required": {
    "translation": "Şifre gereklidir."
  },
  "set_password.password.error.tooShort": {
    "translation": "Şifre en az 8 karakter olmalıdır."
  },
  "set_password.password.error.tooLong": {
    "translation": "Şifre en fazla 72 karakter olmalıdır."
  },
  "set_password.password.error.needsUppercase": {
    "translation": "Şifre en az bir büyük harf içermelidir."
  },
  "set_password.password.error.needsNumber": {
    "translation": "Şifre en az bir rakam içermelidir."
  },
  "set_password.password.error.needsSpecial": {
    "translation": "Şifre en az bir özel karakter içermelidir."
  },
  "set_password.password.rules.length": {
    "translation": "En az 8 karakter"
  },
  "set_password.password.rules.maxLength": {
    "translation": "72 karakter veya daha az"
  },
  "set_password.password.rules.uppercase": {
    "translation": "En az bir büyük harf"
  },
  "set_password.password.rules.number": {
    "translation": "En az bir rakam"
  },
  "set_password.password.rules.special": {
    "translation": "En az bir özel karakter"
  },
  "set_password.confirmPassword.label": {
    "translation": "Şifreyi Onayla"
  },
  "set_password.confirmPassword.placeholder": {
    "translation": "Şifrenizi tekrar girin"
  },
  "set_password.confirmPassword.show": {
    "translation": "Şifre onayını göster"
  },
  "set_password.confirmPassword.hide": {
    "translation": "Şifre onayını gizle"
  },
  "set_password.confirmPassword.error.required": {
    "translation": "Lütfen şifrenizi onaylayın."
  },
  "set_password.confirmPassword.error.mismatch": {
    "translation": "Şifreler eşleşmiyor."
  },
  "set_password.submit": {
    "translation": "Şifreyi Belirle ve Giriş Yap"
  },
  "set_password.submitting": {
    "translation": "Şifre belirleniyor..."
  },
  "set_password.error.tokenInvalid": {
    "translation": "Bu bağlantı geçersiz veya zaten kullanılmış."
  },
  "set_password.error.tokenExpired": {
    "translation": "Bu bağlantının süresi doldu. Lütfen yeni bir tane isteyin."
  },
  "forgot_password.meta.title": {
    "translation": "Şifrenizi sıfırlayın — {{brandName}} Geliştirici"
  },
  "forgot_password.meta.description": {
    "translation": "{{brandName}} Geliştirici hesabınız için şifre sıfırlama bağlantısı isteyin."
  },
  "forgot_password.heading": {
    "translation": "Şifrenizi mi unuttunuz?"
  },
  "forgot_password.subtitle": {
    "translation": "İş e-postanızı girin, size bir sıfırlama bağlantısı gönderelim."
  },
  "forgot_password.email.label": {
    "translation": "İş E-postası"
  },
  "forgot_password.email.placeholder": {
    "translation": "siz@sirket.com"
  },
  "forgot_password.email.error.required": {
    "translation": "E-posta gereklidir."
  },
  "forgot_password.email.error.invalid": {
    "translation": "Geçerli bir e-posta adresi girin (örn. siz@sirket.com)."
  },
  "forgot_password.email.error.nonWork": {
    "translation": "Lütfen şirket iş e-postanızı kullanın."
  },
  "forgot_password.submit": {
    "translation": "Sıfırlama Bağlantısı Gönder"
  },
  "forgot_password.submitting": {
    "translation": "Gönderiliyor..."
  },
  "forgot_password.sent.message": {
    "translation": "Bu e-posta kayıtlıysa, kısa süre içinde bir sıfırlama bağlantısı alacaksınız."
  },
  "forgot_password.sent.resend": {
    "translation": "Başka bir bağlantı gönder"
  },
  "forgot_password.sent.cooldown": {
    "translation": "{{seconds}} saniye içinde yeniden gönderebilirsiniz."
  },
  "forgot_password.cta.backToLogin": {
    "translation": "Girişe Dön"
  },
  "link_expired.meta.title": {
    "translation": "Bağlantının süresi doldu — {{brandName}} Geliştirici"
  },
  "link_expired.meta.description": {
    "translation": "Doğrulama bağlantınızın süresi doldu."
  },
  "link_expired.heading": {
    "translation": "Bağlantının süresi doldu"
  },
  "link_expired.message": {
    "translation": "Doğrulama bağlantınızın süresi doldu veya geçersiz. Aşağıdan yeni bir bağlantı isteyin."
  },
  "link_expired.resend.submit": {
    "translation": "Yeni Bağlantı İste"
  },
  "link_expired.resend.submitting": {
    "translation": "Gönderiliyor..."
  },
  "link_expired.resend.sent": {
    "translation": "E-posta adresinize yeni bir bağlantı gönderildi."
  },
  "link_expired.resend.cooldown": {
    "translation": "{{seconds}} saniye içinde yeni bir bağlantı isteyebilirsiniz."
  },
  "link_expired.cta.backToLogin": {
    "translation": "Girişe Dön"
  },
  "app_nav.dashboard": {
    "translation": "Gösterge Paneli"
  },
  "app_nav.credentials": {
    "translation": "Kimlik Bilgileri"
  },
  "app_nav.vendors": {
    "translation": "Ortaklar"
  },
  "app_nav.docs": {
    "translation": "Belgeler"
  },
  "app_nav.support": {
    "translation": "Destek"
  },
  "app_nav.logout": {
    "translation": "Çıkış Yap"
  },
  "app_nav.lockedTooltip": {
    "translation": "Başvuru onayından sonra kullanılabilir"
  },
  "app_nav.collapseNav": {
    "translation": "Gezinmeyi daralt"
  },
  "app_nav.expandNav": {
    "translation": "Gezinmeyi genişlet"
  },
  "pending_dashboard.meta.title": {
    "translation": "Başvuru Beklemede — {{brandName}} Geliştirici"
  },
  "pending_dashboard.meta.description": {
    "translation": "Başvurunuz inceleniyor."
  },
  "pending_dashboard.alert.info.heading": {
    "translation": "Başvuru inceleme bekliyor"
  },
  "pending_dashboard.alert.info.submittedAt": {
    "translation": "{{date}} tarihinde gönderildi"
  },
  "pending_dashboard.alert.neutral.message": {
    "translation": "Başvurunuz onaylanana kadar destek seçenekleri sınırlıdır."
  },
  "pending_dashboard.welcome": {
    "translation": "Hoş geldiniz, {{name}}"
  },
  "pending_dashboard.body": {
    "translation": "<strong>{{email}}</strong> için başvurunuz inceleniyor. Bu işlem genellikle 2–3 iş günü sürer. Karar verildikten sonra e-posta ile bilgilendireceğiz."
  },
  "pending_dashboard.cta.checkStatus": {
    "translation": "Durumu Kontrol Et"
  },
  "pending_dashboard.cta.support": {
    "translation": "Destekle İletişime Geç"
  },
  "active_dashboard.meta.title": {
    "translation": "Pano — {{brandName}} Geliştirici"
  },
  "active_dashboard.meta.description": {
    "translation": "Hesabınız onaylandı ve aktif."
  },
  "active_dashboard.alert.success": {
    "translation": "Hesabınız onaylandı ve aktif. {{brandName}} Geliştirici'ye hoş geldiniz."
  },
  "active_dashboard.welcome": {
    "translation": "Tekrar hoş geldiniz, {{name}}"
  },
  "active_dashboard.subtitle": {
    "translation": "{{company}} · {{email}}"
  },
  "active_dashboard.tag": {
    "translation": "Onaylandı · {{date}}"
  },
  "active_dashboard.quickAccess.heading": {
    "translation": "Hızlı erişim"
  },
  "active_dashboard.quickAccess.open": {
    "translation": "Aç"
  },
  "active_dashboard.quickAccess.credentials.label": {
    "translation": "API Kimlik Bilgileri"
  },
  "active_dashboard.quickAccess.credentials.description": {
    "translation": "API anahtarınızı görüntüleyin ve yenileyin."
  },
  "active_dashboard.quickAccess.vendors.label": {
    "translation": "Satıcılar"
  },
  "active_dashboard.quickAccess.vendors.description": {
    "translation": "Bağlı satıcıları yönetin ve yeni satıcılar ekleyin."
  },
  "active_dashboard.quickAccess.support.label": {
    "translation": "Destek"
  },
  "active_dashboard.quickAccess.support.description": {
    "translation": "Talep açın ve sorun çözümünü takip edin."
  },
  "active_dashboard.quickAccess.docs.label": {
    "translation": "API Belgeleri"
  },
  "active_dashboard.quickAccess.docs.description": {
    "translation": "Ara yazılım ve eklenti uç noktası referanslarına göz atın."
  },
  "support.meta.title": {
    "translation": "Destek — {{brandName}} Geliştirici"
  },
  "support.meta.description": {
    "translation": "Destek taleplerinizi görüntüleyin ve yönetin."
  },
  "support.heading": {
    "translation": "Destek"
  },
  "support.newTicket": {
    "translation": "Yeni Talep Oluştur"
  },
  "support.submitted": {
    "translation": "{{id}} numaralı talep gönderildi. 3–5 iş günü içinde sizinle iletişime geçeceğiz."
  },
  "support.empty.heading": {
    "translation": "Henüz talep yok"
  },
  "support.empty.message": {
    "translation": "Entegrasyonunuzla ilgili yardım için bir talep oluşturun."
  },
  "support.table.id": {
    "translation": "ID"
  },
  "support.table.subject": {
    "translation": "Konu"
  },
  "support.table.category": {
    "translation": "Kategori"
  },
  "support.table.status": {
    "translation": "Durum"
  },
  "support.table.lastActivity": {
    "translation": "Son aktivite"
  },
  "support.status.open": {
    "translation": "Açık"
  },
  "support.status.in_progress": {
    "translation": "İşlemde"
  },
  "support.status.closed": {
    "translation": "Kapalı"
  },
  "support.category.application_status": {
    "translation": "Başvuru Durumu"
  },
  "support.category.technical_question": {
    "translation": "Teknik Soru"
  },
  "support.category.other": {
    "translation": "Diğer"
  },
  "support.category.credentials": {
    "translation": "Kimlik Bilgileri"
  },
  "support.category.vendor_onboarding": {
    "translation": "Satıcı Kaydı"
  },
  "support.category.orders": {
    "translation": "Siparişler"
  },
  "support.category.catalog": {
    "translation": "Katalog"
  },
  "support.new.heading": {
    "translation": "Yeni Destek Talebi"
  },
  "support.new.brand.label": {
    "translation": "Marka"
  },
  "support.new.brand.placeholder": {
    "translation": "Marka seçin"
  },
  "support.new.brand.error.required": {
    "translation": "Marka gereklidir."
  },
  "support.new.relatedVendor.label": {
    "translation": "İlgili Satıcı"
  },
  "support.new.relatedVendor.optional": {
    "translation": "(isteğe bağlı)"
  },
  "support.new.subject.label": {
    "translation": "Konu"
  },
  "support.new.subject.placeholder": {
    "translation": "Sorununuzu kısaca açıklayın"
  },
  "support.new.subject.error.required": {
    "translation": "Konu gereklidir."
  },
  "support.new.category.label": {
    "translation": "Kategori"
  },
  "support.new.category.placeholder": {
    "translation": "Kategori seçin"
  },
  "support.new.category.error.required": {
    "translation": "Kategori gereklidir."
  },
  "support.new.message.label": {
    "translation": "Açıklama"
  },
  "support.new.message.placeholder": {
    "translation": "Sorununuzu ayrıntılı açıklayın (en az 20 karakter)..."
  },
  "support.new.message.error.required": {
    "translation": "Açıklama gereklidir."
  },
  "support.new.message.error.tooShort": {
    "translation": "Açıklama en az 20 karakter olmalıdır."
  },
  "support.new.submit": {
    "translation": "Talebi Gönder"
  },
  "support.new.submitting": {
    "translation": "Gönderiliyor..."
  },
  "support.new.cancel": {
    "translation": "İptal"
  },
  "support.new.submitError": {
    "translation": "Talebiniz gönderilemedi. Taslağınız kaydedildi."
  },
  "support.new.download": {
    "translation": "Talebinizi indirin"
  },
  "support.new.draft.restored": {
    "translation": "Önceki bir oturumdan kaydedilmiş taslağınız var."
  },
  "support.new.draft.discard": {
    "translation": "Sil"
  },
  "support.detail.heading": {
    "translation": "Destek Talebi"
  },
  "support.detail.label.status": {
    "translation": "Durum"
  },
  "support.detail.label.id": {
    "translation": "Talep"
  },
  "support.detail.label.brand": {
    "translation": "Marka"
  },
  "support.detail.label.category": {
    "translation": "Kategori"
  },
  "support.detail.label.created": {
    "translation": "Oluşturulma"
  },
  "support.detail.label.lastActivity": {
    "translation": "Son aktivite"
  },
  "support.detail.label.message": {
    "translation": "Açıklama"
  },
  "support.detail.label.relatedVendors": {
    "translation": "İlgili Satıcılar"
  },
  "support.detail.thread.heading": {
    "translation": "Aktivite"
  },
  "support.detail.thread.systemRole": {
    "translation": "Sistem"
  },
  "support.detail.thread.systemEvent": {
    "translation": "Talep açıldı"
  },
  "support.detail.thread.supportRole": {
    "translation": "Destek Ekibi"
  },
  "support.detail.thread.partnerRole": {
    "translation": "Siz"
  },
  "support.detail.thread.mockReply": {
    "translation": "Bize ulaştığınız için teşekkür ederiz. Talebinizi inceliyoruz ve 3–5 iş günü içinde size geri döneceğiz."
  },
  "support.detail.reply.label": {
    "translation": "Yanıtla"
  },
  "support.detail.reply.placeholder": {
    "translation": "Yanıtınızı yazın..."
  },
  "support.detail.reply.submit": {
    "translation": "Yanıt gönder"
  },
  "support.detail.reply.sending": {
    "translation": "Gönderiliyor..."
  },
  "support.detail.reply.errorToast": {
    "translation": "Yanıt gönderilemedi. Tekrar deneyin."
  },
  "support.detail.closed.note": {
    "translation": "Bu talep kapatıldı. Artık yanıt eklenemez."
  },
  "support.detail.close": {
    "translation": "Kapat"
  },
  "vendors.meta.title": {
    "translation": "Bağlı Satıcılar — {{brandName}} Geliştirici"
  },
  "vendors.meta.description": {
    "translation": "Tüm platformlardaki bağlı satıcılarınızı görüntüleyin ve yönetin."
  },
  "vendors.heading": {
    "translation": "Bağlı Satıcılar"
  },
  "vendors.addVendor": {
    "translation": "+ Satıcı Ekle"
  },
  "vendors.addSuccess": {
    "translation": "{{vendorId}} satıcısı başarıyla gönderildi. Durum: BEKLEMEDE."
  },
  "vendors.statusNote": {
    "translation": "Durum her ~60 saniyede bir güncellenir."
  },
  "vendors.pendingSubmissions": {
    "translation": "Bekleyen Başvurular"
  },
  "vendors.empty": {
    "translation": "Aramanızla eşleşen satıcı bulunamadı."
  },
  "vendors.search.placeholder": {
    "translation": "Ad veya kimliğe göre ara..."
  },
  "vendors.filter.integration": {
    "translation": "Entegrasyon"
  },
  "vendors.filter.vendorGroup": {
    "translation": "Tedarikçi Grubu"
  },
  "vendors.filter.clearAll": {
    "translation": "Tümünü temizle"
  },
  "vendors.add.heading": {
    "translation": "Satıcı Ekle"
  },
  "vendors.add.close": {
    "translation": "Kapat"
  },
  "vendors.add.platform.label": {
    "translation": "Platform"
  },
  "vendors.add.platform.placeholder": {
    "translation": "Platform seçin"
  },
  "vendors.add.country.label": {
    "translation": "Ülke"
  },
  "vendors.add.country.placeholder": {
    "translation": "Ülke seçin"
  },
  "vendors.add.country.placeholderNoPlatform": {
    "translation": "Önce platform seçin"
  },
  "vendors.add.vendorCode.label": {
    "translation": "Satıcı Kodu"
  },
  "vendors.add.vendorCode.placeholder": {
    "translation": "örn. 12345"
  },
  "vendors.add.vendorCode.helper": {
    "translation": "DH iletişim kişinizin sağladığı kod."
  },
  "vendors.add.vendorCode.error.required": {
    "translation": "Satıcı kodu gereklidir."
  },
  "vendors.add.preview.label": {
    "translation": "Gönderilecek satıcı kimliği:"
  },
  "vendors.add.submit": {
    "translation": "Satıcıyı Gönder"
  },
  "vendors.add.submitting": {
    "translation": "Gönderiliyor..."
  },
  "vendors.add.error.duplicate": {
    "translation": "Bu satıcı zaten hesabınıza bağlı."
  },
  "vendors.add.error.unavailable": {
    "translation": "Ekleme hizmeti geçici olarak kullanılamıyor. Lütfen daha sonra tekrar deneyin."
  },
  "vendors.add.error.submission": {
    "translation": "Bir şeyler yanlış gitti. Lütfen tekrar deneyin."
  },
  "vendors.add.cancel": {
    "translation": "İptal"
  },
  "vendors.status.active": {
    "translation": "Aktif"
  },
  "vendors.status.inactive": {
    "translation": "Pasif"
  },
  "vendors.status.pending": {
    "translation": "Beklemede"
  },
  "vendors.status.rejected": {
    "translation": "Reddedildi"
  },
  "credentials.meta.title": {
    "translation": "API Kimlik Bilgileri — {{brandName}} Geliştirici"
  },
  "credentials.meta.description": {
    "translation": "DH POS entegrasyonu için API kimlik bilgilerinizi görüntüleyin ve yönetin."
  },
  "credentials.heading": {
    "translation": "API Kimlik Bilgileri"
  },
  "credentials.subtitle": {
    "translation": "DH POS API'leriyle entegrasyonunuzun kimliğini doğrulamak için bu bilgileri kullanın."
  },
  "credentials.copied": {
    "translation": "Panoya kopyalandı"
  },
  "credentials.apiKey.label": {
    "translation": "Üretim API Anahtarı"
  },
  "credentials.apiKey.tag": {
    "translation": "Üretim"
  },
  "credentials.apiKey.reveal": {
    "translation": "Göster"
  },
  "credentials.apiKey.hide": {
    "translation": "Gizle ({{countdown}} s)"
  },
  "credentials.apiKey.hidesIn": {
    "translation": "{{countdown}} saniyede gizlenir"
  },
  "credentials.apiKey.copy": {
    "translation": "Anahtarı Kopyala"
  },
  "credentials.apiKey.warning": {
    "translation": "Bu anahtarı güvende tutun. Asla paylaşmayın veya kaynak koda eklemeyin."
  },
  "credentials.chainCode.label": {
    "translation": "Zincir Kodu"
  },
  "credentials.chainCode.copy": {
    "translation": "Zincir Kodunu Kopyala"
  },
  "credentials.rotation.heading": {
    "translation": "API anahtarınızı değiştirmeniz mi gerekiyor?"
  },
  "credentials.rotation.body": {
    "translation": "Bir destek talebi gönderin. Anahtar değiştirme işlemi DH ekibi tarafından gerçekleştirilir."
  },
  "credentials.rotation.cta": {
    "translation": "Destek Talebi Oluştur"
  },
  "lang_selector.label": {
    "translation": "Dil"
  },
  "lang_selector.en": {
    "translation": "English"
  },
  "lang_selector.ar": {
    "translation": "العربية"
  },
  "lang_selector.tr": {
    "translation": "Türkçe"
  },
  "error.401.heading": {
    "translation": "Oturum süresi doldu"
  },
  "error.401.message": {
    "translation": "Oturumunuzun süresi doldu. Lütfen tekrar giriş yapın."
  },
  "error.403.heading": {
    "translation": "Erişim reddedildi"
  },
  "error.403.message": {
    "translation": "Bu sayfayı görüntüleme izniniz yok."
  },
  "error.404.heading": {
    "translation": "Sayfa bulunamadı"
  },
  "error.404.message": {
    "translation": "Aradığınız sayfa mevcut değil."
  },
  "error.default.heading": {
    "translation": "Bir şeyler ters gitti"
  },
  "error.default.message": {
    "translation": "Beklenmeyen bir hata oluştu. Lütfen tekrar deneyin."
  },
  "lang_selector.es": {
    "translation": ""
  },
  "lang_selector.es-ES": {
    "translation": ""
  },
  "auth_nav.backToLogin": {
    "translation": ""
  },
  "vendors.add.integration.label": {
    "translation": "Entegrasyon"
  },
  "vendors.add.integration.placeholder": {
    "translation": "Entegrasyon seçin"
  },
  "vendors.add.noIntegrations": {
    "translation": "Hesabınıza henüz herhangi bir entegrasyon bağlı değil. Satıcı eklemeden önce entegrasyonunuzu kurmak için lütfen destek ekibiyle iletişime geçin."
  },
  "vendors.add.vendorGroup.label": {
    "translation": "Satıcı Grubu"
  },
  "vendors.add.vendorGroup.placeholder": {
    "translation": "Satıcı grubu seçin"
  },
  "vendors.add.vendorGroup.placeholderNoIntegration": {
    "translation": "Önce entegrasyon seçin"
  },
  "vendors.add.vendorGroup.helper": {
    "translation": ""
  },
  "vendors.add.posVendorId.label": {
    "translation": "Uzak Satıcı Kimliği"
  },
  "vendors.add.posVendorId.placeholder": {
    "translation": "örn. KFC_001"
  },
  "vendors.add.posVendorId.helper": {
    "translation": "DH iletişim kişinizin sağladığı POS satıcı kimliği."
  },
  "vendors.add.posVendorId.error.required": {
    "translation": "Uzak Satıcı Kimliği gereklidir."
  },
  "docs.endpoint.authHeaderDesc": {
    "translation": "Kimlik Doğrulama uç noktasından alınan Bearer token. Biçim:"
  },
  "docs.endpoint.bodyDefaultDesc": {
    "translation": "JSON yükü. Beklenen yapı için kod örneğine bakın."
  },
  "docs.endpoint.contentTypeDesc": {
    "translation": "Şu olmalıdır:"
  },
  "docs.endpoint.deprecated": {
    "translation": "Bu uç nokta kullanımdan kaldırılmıştır."
  },
  "docs.endpoint.deprecatedInstead": {
    "translation": "kullanın."
  },
  "docs.endpoint.deprecatedUse": {
    "translation": "Bunun yerine"
  },
  "docs.endpoint.dynamicUrlBody": {
    "translation": "Bu uç nokta, entegrasyon kurulumu sırasında kayıtlı bir URL kullanır — gerçek bir yol değildir."
  },
  "docs.endpoint.dynamicUrlTitle": {
    "translation": "Dinamik geri çağırma URL'si"
  },
  "docs.endpoint.paramColDesc": {
    "translation": "Açıklama"
  },
  "docs.endpoint.paramColName": {
    "translation": "Parametre"
  },
  "docs.endpoint.pathParams": {
    "translation": "Yol Parametreleri"
  },
  "docs.endpoint.queryParams": {
    "translation": "Sorgu Parametreleri"
  },
  "docs.endpoint.requestBody": {
    "translation": "İstek Gövdesi"
  },
  "docs.endpoint.requestHeaders": {
    "translation": "İstek Başlıkları"
  },
  "docs.endpoint.required": {
    "translation": "zorunlu"
  },
  "docs.endpoint.responseSample": {
    "translation": "Yanıt"
  },
  "docs.endpoint.responses": {
    "translation": "Yanıtlar"
  },
  "docs.endpoint.codeTab.curl": {
    "translation": ""
  },
  "docs.endpoint.codeTab.js": {
    "translation": ""
  },
  "docs.endpoint.jsComment.replaceBody": {
    "translation": ""
  },
  "docs.meta.home.title": {
    "translation": ""
  },
  "docs.meta.detail.titleFallback": {
    "translation": ""
  },
  "docs.meta.titleTemplate": {
    "translation": ""
  },
  "docs.heading": {
    "translation": "API Referansı ve Geliştirici Kılavuzları"
  },
  "docs.menuClose": {
    "translation": "Gezinti menüsünü kapat"
  },
  "docs.menuCloseLabel": {
    "translation": "KAPAT"
  },
  "docs.menuOpen": {
    "translation": "Gezinti menüsünü aç"
  },
  "docs.menuOpenLabel": {
    "translation": "MENÜ"
  },
  "docs.nav.aria": {
    "translation": "API belgeleri bölümleri"
  },
  "docs.searchPlaceholder": {
    "translation": "Uç noktaları ve kılavuzları arayın..."
  },
  "docs.sectionMeta.endpoints_one": {
    "translation": "{{count}} uç nokta"
  },
  "docs.sectionMeta.endpoints_other": {
    "translation": "{{count}} uç nokta"
  },
  "docs.sectionMeta.guides_one": {
    "translation": "{{count}} kılavuz"
  },
  "docs.sectionMeta.guides_other": {
    "translation": "{{count}} kılavuz"
  },
  "docs.subtitle": {
    "translation": "POS Middleware ve Plugin API'leri için eksiksiz referans. Delivery Hero'nun sipariş altyapısıyla doğrudan entegrasyon."
  },
  "docs.version": {
    "translation": "POS API"
  },
  "support.new.relatedVendor.placeholder": {
    "translation": "Satıcı seçin"
  },
  "support.new.relatedVendor.search": {
    "translation": "Satıcıları ara"
  },
  "support.new.relatedVendor.more": {
    "translation": "+{{count}} tane daha"
  },
  "support.new.relatedVendor.noResults": {
    "translation": "Aramanızla eşleşen satıcı bulunamadı."
  },
  "docs.content.sections.guides.title": {
    "translation": ""
  },
  "docs.content.sections.guides.description": {
    "translation": ""
  },
  "docs.content.sections.middleware.title": {
    "translation": ""
  },
  "docs.content.sections.middleware.description": {
    "translation": ""
  },
  "docs.content.sections.plugin.title": {
    "translation": ""
  },
  "docs.content.sections.plugin.description": {
    "translation": ""
  },
  "docs.content.sections.reference.title": {
    "translation": ""
  },
  "docs.content.sections.reference.description": {
    "translation": ""
  },
  "docs.content.nav.guides.getting-started.title": {
    "translation": ""
  },
  "docs.content.nav.guides.access-integration.title": {
    "translation": ""
  },
  "docs.content.nav.middleware.authentication.token.title": {
    "translation": ""
  },
  "docs.content.nav.middleware.orders.create.title": {
    "translation": ""
  },
  "docs.content.nav.middleware.orders.update-status.title": {
    "translation": ""
  },
  "docs.content.nav.middleware.orders.get.title": {
    "translation": ""
  },
  "docs.content.nav.middleware.vendors.availability.title": {
    "translation": ""
  },
  "docs.content.nav.middleware.vendors.info.title": {
    "translation": ""
  },
  "docs.content.nav.middleware.catalog.import.title": {
    "translation": ""
  },
  "docs.content.nav.middleware.catalog.item-availability.title": {
    "translation": ""
  },
  "docs.content.nav.middleware.reports.order-reporting.title": {
    "translation": ""
  },
  "docs.content.nav.middleware.orders.create-legacy.title": {
    "translation": ""
  },
  "docs.content.nav.plugin.orders.dispatch.title": {
    "translation": ""
  },
  "docs.content.nav.plugin.orders.update-status.title": {
    "translation": ""
  },
  "docs.content.nav.plugin.catalog.menu-import.title": {
    "translation": ""
  },
  "docs.content.nav.plugin.catalog.import-callback.title": {
    "translation": ""
  },
  "docs.content.nav.reference.order-management.title": {
    "translation": ""
  },
  "docs.content.nav.reference.catalog-management.title": {
    "translation": ""
  },
  "docs.content.nav.reference.store-management.title": {
    "translation": ""
  },
  "docs.content.nav.reference.order-report-service.title": {
    "translation": ""
  },
  "docs.content.nav.reference.terminology.title": {
    "translation": ""
  },
  "docs.content.nav.reference.faq.title": {
    "translation": ""
  },
  "docs.content.nav.reference.post-production.title": {
    "translation": ""
  },
  "docs.content.response.400.label": {
    "translation": ""
  },
  "docs.content.response.400.description": {
    "translation": ""
  },
  "docs.content.response.401.label": {
    "translation": ""
  },
  "docs.content.response.401.description": {
    "translation": ""
  },
  "docs.content.response.500.label": {
    "translation": ""
  },
  "docs.content.response.500.description": {
    "translation": ""
  },
  "docs.content.ep.middleware.authentication.token.title": {
    "translation": ""
  },
  "docs.content.ep.middleware.authentication.token.description": {
    "translation": ""
  },
  "docs.content.ep.middleware.authentication.token.body": {
    "translation": ""
  },
  "docs.content.ep.middleware.authentication.token.r200.label": {
    "translation": ""
  },
  "docs.content.ep.middleware.authentication.token.r200.description": {
    "translation": ""
  },
  "docs.content.ep.middleware.orders.create.title": {
    "translation": ""
  },
  "docs.content.ep.middleware.orders.create.description": {
    "translation": ""
  },
  "docs.content.ep.middleware.orders.create.body": {
    "translation": ""
  },
  "docs.content.ep.middleware.orders.create.r201.label": {
    "translation": ""
  },
  "docs.content.ep.middleware.orders.create.r201.description": {
    "translation": ""
  },
  "docs.content.ep.middleware.orders.update-status.title": {
    "translation": ""
  },
  "docs.content.ep.middleware.orders.update-status.description": {
    "translation": ""
  },
  "docs.content.ep.middleware.orders.update-status.body": {
    "translation": ""
  },
  "docs.content.ep.middleware.orders.update-status.param.orderId": {
    "translation": ""
  },
  "docs.content.ep.middleware.orders.update-status.r200.label": {
    "translation": ""
  },
  "docs.content.ep.middleware.orders.update-status.r200.description": {
    "translation": ""
  },
  "docs.content.ep.middleware.orders.get.title": {
    "translation": ""
  },
  "docs.content.ep.middleware.orders.get.description": {
    "translation": ""
  },
  "docs.content.ep.middleware.orders.get.param.orderId": {
    "translation": ""
  },
  "docs.content.ep.middleware.orders.get.query.include": {
    "translation": ""
  },
  "docs.content.ep.middleware.orders.get.r200.label": {
    "translation": ""
  },
  "docs.content.ep.middleware.orders.get.r200.description": {
    "translation": ""
  },
  "docs.content.ep.middleware.orders.create-legacy.title": {
    "translation": ""
  },
  "docs.content.ep.middleware.orders.create-legacy.description": {
    "translation": ""
  },
  "docs.content.ep.middleware.orders.create-legacy.r201.label": {
    "translation": ""
  },
  "docs.content.ep.middleware.orders.create-legacy.r201.description": {
    "translation": ""
  },
  "docs.content.ep.middleware.vendors.availability.title": {
    "translation": ""
  },
  "docs.content.ep.middleware.vendors.availability.description": {
    "translation": ""
  },
  "docs.content.ep.middleware.vendors.availability.body": {
    "translation": ""
  },
  "docs.content.ep.middleware.vendors.availability.param.vendorId": {
    "translation": ""
  },
  "docs.content.ep.middleware.vendors.availability.r200.label": {
    "translation": ""
  },
  "docs.content.ep.middleware.vendors.availability.r200.description": {
    "translation": ""
  },
  "docs.content.ep.middleware.vendors.info.title": {
    "translation": ""
  },
  "docs.content.ep.middleware.vendors.info.description": {
    "translation": ""
  },
  "docs.content.ep.middleware.vendors.info.param.vendorId": {
    "translation": ""
  },
  "docs.content.ep.middleware.vendors.info.r200.label": {
    "translation": ""
  },
  "docs.content.ep.middleware.vendors.info.r200.description": {
    "translation": ""
  },
  "docs.content.ep.middleware.catalog.import.title": {
    "translation": ""
  },
  "docs.content.ep.middleware.catalog.import.description": {
    "translation": ""
  },
  "docs.content.ep.middleware.catalog.import.body": {
    "translation": ""
  },
  "docs.content.ep.middleware.catalog.import.r202.label": {
    "translation": ""
  },
  "docs.content.ep.middleware.catalog.import.r202.description": {
    "translation": ""
  },
  "docs.content.ep.middleware.catalog.item-availability.title": {
    "translation": ""
  },
  "docs.content.ep.middleware.catalog.item-availability.description": {
    "translation": ""
  },
  "docs.content.ep.middleware.catalog.item-availability.body": {
    "translation": ""
  },
  "docs.content.ep.middleware.catalog.item-availability.param.itemId": {
    "translation": ""
  },
  "docs.content.ep.middleware.catalog.item-availability.r200.label": {
    "translation": ""
  },
  "docs.content.ep.middleware.catalog.item-availability.r200.description": {
    "translation": ""
  },
  "docs.content.ep.middleware.reports.order-reporting.title": {
    "translation": ""
  },
  "docs.content.ep.middleware.reports.order-reporting.description": {
    "translation": ""
  },
  "docs.content.ep.middleware.reports.order-reporting.query.from": {
    "translation": ""
  },
  "docs.content.ep.middleware.reports.order-reporting.query.to": {
    "translation": ""
  },
  "docs.content.ep.middleware.reports.order-reporting.query.vendorId": {
    "translation": ""
  },
  "docs.content.ep.middleware.reports.order-reporting.r200.label": {
    "translation": ""
  },
  "docs.content.ep.middleware.reports.order-reporting.r200.description": {
    "translation": ""
  },
  "docs.content.ep.plugin.orders.dispatch.title": {
    "translation": ""
  },
  "docs.content.ep.plugin.orders.dispatch.description": {
    "translation": ""
  },
  "docs.content.ep.plugin.orders.dispatch.body": {
    "translation": ""
  },
  "docs.content.ep.plugin.orders.dispatch.r200.label": {
    "translation": ""
  },
  "docs.content.ep.plugin.orders.dispatch.r200.description": {
    "translation": ""
  },
  "docs.content.ep.plugin.orders.dispatch.r500.label": {
    "translation": ""
  },
  "docs.content.ep.plugin.orders.dispatch.r500.description": {
    "translation": ""
  },
  "docs.content.ep.plugin.orders.update-status.title": {
    "translation": ""
  },
  "docs.content.ep.plugin.orders.update-status.description": {
    "translation": ""
  },
  "docs.content.ep.plugin.orders.update-status.body": {
    "translation": ""
  },
  "docs.content.ep.plugin.orders.update-status.r200.label": {
    "translation": ""
  },
  "docs.content.ep.plugin.orders.update-status.r200.description": {
    "translation": ""
  },
  "docs.content.ep.plugin.orders.update-status.r500.label": {
    "translation": ""
  },
  "docs.content.ep.plugin.orders.update-status.r500.description": {
    "translation": ""
  },
  "docs.content.ep.plugin.catalog.menu-import.title": {
    "translation": ""
  },
  "docs.content.ep.plugin.catalog.menu-import.description": {
    "translation": ""
  },
  "docs.content.ep.plugin.catalog.menu-import.r200.label": {
    "translation": ""
  },
  "docs.content.ep.plugin.catalog.menu-import.r200.description": {
    "translation": ""
  },
  "docs.content.ep.plugin.catalog.menu-import.r500.label": {
    "translation": ""
  },
  "docs.content.ep.plugin.catalog.menu-import.r500.description": {
    "translation": ""
  },
  "docs.content.ep.plugin.catalog.import-callback.title": {
    "translation": ""
  },
  "docs.content.ep.plugin.catalog.import-callback.description": {
    "translation": ""
  },
  "docs.content.ep.plugin.catalog.import-callback.body": {
    "translation": ""
  },
  "docs.content.ep.plugin.catalog.import-callback.param.catalogImportCallback": {
    "translation": ""
  },
  "docs.content.ep.plugin.catalog.import-callback.r200.label": {
    "translation": ""
  },
  "docs.content.ep.plugin.catalog.import-callback.r200.description": {
    "translation": ""
  },
  "docs.content.ep.plugin.catalog.import-callback.r500.label": {
    "translation": ""
  },
  "docs.content.ep.plugin.catalog.import-callback.r500.description": {
    "translation": ""
  },
  "docs.content.guide.getting-started.title": {
    "translation": ""
  },
  "docs.content.guide.getting-started.b0.text": {
    "translation": ""
  },
  "docs.content.guide.getting-started.b1.text": {
    "translation": ""
  },
  "docs.content.guide.getting-started.b2.i0": {
    "translation": ""
  },
  "docs.content.guide.getting-started.b2.i1": {
    "translation": ""
  },
  "docs.content.guide.getting-started.b3.text": {
    "translation": ""
  },
  "docs.content.guide.getting-started.b4.text": {
    "translation": ""
  },
  "docs.content.guide.getting-started.b5.i0.title": {
    "translation": ""
  },
  "docs.content.guide.getting-started.b5.i0.body": {
    "translation": ""
  },
  "docs.content.guide.getting-started.b5.i1.title": {
    "translation": ""
  },
  "docs.content.guide.getting-started.b5.i1.body": {
    "translation": ""
  },
  "docs.content.guide.getting-started.b5.i2.title": {
    "translation": ""
  },
  "docs.content.guide.getting-started.b5.i2.body": {
    "translation": ""
  },
  "docs.content.guide.getting-started.b5.i3.title": {
    "translation": ""
  },
  "docs.content.guide.getting-started.b5.i3.body": {
    "translation": ""
  },
  "docs.content.guide.getting-started.b5.i4.title": {
    "translation": ""
  },
  "docs.content.guide.getting-started.b5.i4.body": {
    "translation": ""
  },
  "docs.content.guide.getting-started.b5.i5.title": {
    "translation": ""
  },
  "docs.content.guide.getting-started.b5.i5.body": {
    "translation": ""
  },
  "docs.content.guide.getting-started.b5.i6.title": {
    "translation": ""
  },
  "docs.content.guide.getting-started.b5.i6.body": {
    "translation": ""
  },
  "docs.content.guide.getting-started.b5.i7.title": {
    "translation": ""
  },
  "docs.content.guide.getting-started.b5.i7.body": {
    "translation": ""
  },
  "docs.content.guide.access-integration.title": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b0.text": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b1.text": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b2.i0.title": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b2.i0.body": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b2.i1.title": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b2.i1.body": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b2.i2.title": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b2.i2.body": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b2.i3.title": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b2.i3.body": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b2.i4.title": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b2.i4.body": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b3.text": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b4.text": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b5.text": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b6.i0.term": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b6.i0.def": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b6.i1.term": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b6.i1.def": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b6.i2.term": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b6.i2.def": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b7.text": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b8.i0": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b8.i1": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b8.i2": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b9.text": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b10.text": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.h0": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.h1": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.h2": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r0.c0": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r0.c1": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r0.c2": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r1.c0": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r1.c1": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r1.c2": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r2.c0": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r2.c1": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r2.c2": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r3.c0": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r3.c1": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r3.c2": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r4.c0": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r4.c1": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r4.c2": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r5.c0": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r5.c1": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r5.c2": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r6.c0": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r6.c1": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r6.c2": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r7.c0": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r7.c1": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r7.c2": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r8.c0": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r8.c1": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r8.c2": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r9.c0": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r9.c1": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b11.r9.c2": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b12.text": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b13.text": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b14.h0": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b14.h1": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b14.r0.c0": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b14.r0.c1": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b14.r1.c0": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b14.r1.c1": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b14.r2.c0": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b14.r2.c1": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b14.r3.c0": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b14.r3.c1": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b14.r4.c0": {
    "translation": ""
  },
  "docs.content.guide.access-integration.b14.r4.c1": {
    "translation": ""
  },
  "docs.content.guide.order-management.title": {
    "translation": ""
  },
  "docs.content.guide.order-management.b0.text": {
    "translation": ""
  },
  "docs.content.guide.order-management.b1.text": {
    "translation": ""
  },
  "docs.content.guide.order-management.b2.text": {
    "translation": ""
  },
  "docs.content.guide.order-management.b3.i0.body": {
    "translation": ""
  },
  "docs.content.guide.order-management.b3.i1.body": {
    "translation": ""
  },
  "docs.content.guide.order-management.b3.i2.body": {
    "translation": ""
  },
  "docs.content.guide.order-management.b3.i3.body": {
    "translation": ""
  },
  "docs.content.guide.order-management.b3.i4.body": {
    "translation": ""
  },
  "docs.content.guide.order-management.b4.text": {
    "translation": ""
  },
  "docs.content.guide.order-management.b5.text": {
    "translation": ""
  },
  "docs.content.guide.order-management.b6.i0.body": {
    "translation": ""
  },
  "docs.content.guide.order-management.b6.i1.body": {
    "translation": ""
  },
  "docs.content.guide.order-management.b6.i2.body": {
    "translation": ""
  },
  "docs.content.guide.order-management.b6.i3.body": {
    "translation": ""
  },
  "docs.content.guide.order-management.b7.text": {
    "translation": ""
  },
  "docs.content.guide.order-management.b8.h0": {
    "translation": ""
  },
  "docs.content.guide.order-management.b8.h1": {
    "translation": ""
  },
  "docs.content.guide.order-management.b8.h2": {
    "translation": ""
  },
  "docs.content.guide.order-management.b8.r0.c0": {
    "translation": ""
  },
  "docs.content.guide.order-management.b8.r0.c1": {
    "translation": ""
  },
  "docs.content.guide.order-management.b8.r0.c2": {
    "translation": ""
  },
  "docs.content.guide.order-management.b8.r1.c0": {
    "translation": ""
  },
  "docs.content.guide.order-management.b8.r1.c1": {
    "translation": ""
  },
  "docs.content.guide.order-management.b8.r1.c2": {
    "translation": ""
  },
  "docs.content.guide.order-management.b8.r2.c0": {
    "translation": ""
  },
  "docs.content.guide.order-management.b8.r2.c1": {
    "translation": ""
  },
  "docs.content.guide.order-management.b8.r2.c2": {
    "translation": ""
  },
  "docs.content.guide.order-management.b8.r3.c0": {
    "translation": ""
  },
  "docs.content.guide.order-management.b8.r3.c1": {
    "translation": ""
  },
  "docs.content.guide.order-management.b8.r3.c2": {
    "translation": ""
  },
  "docs.content.guide.catalog-management.title": {
    "translation": ""
  },
  "docs.content.guide.catalog-management.b0.text": {
    "translation": ""
  },
  "docs.content.guide.catalog-management.b1.text": {
    "translation": ""
  },
  "docs.content.guide.catalog-management.b2.i0.title": {
    "translation": ""
  },
  "docs.content.guide.catalog-management.b2.i0.body": {
    "translation": ""
  },
  "docs.content.guide.catalog-management.b2.i1.title": {
    "translation": ""
  },
  "docs.content.guide.catalog-management.b2.i1.body": {
    "translation": ""
  },
  "docs.content.guide.catalog-management.b2.i2.title": {
    "translation": ""
  },
  "docs.content.guide.catalog-management.b2.i2.body": {
    "translation": ""
  },
  "docs.content.guide.catalog-management.b2.i3.title": {
    "translation": ""
  },
  "docs.content.guide.catalog-management.b2.i3.body": {
    "translation": ""
  },
  "docs.content.guide.catalog-management.b2.i4.title": {
    "translation": ""
  },
  "docs.content.guide.catalog-management.b2.i4.body": {
    "translation": ""
  },
  "docs.content.guide.catalog-management.b3.text": {
    "translation": ""
  },
  "docs.content.guide.catalog-management.b4.text": {
    "translation": ""
  },
  "docs.content.guide.catalog-management.b5.text": {
    "translation": ""
  },
  "docs.content.guide.store-management.title": {
    "translation": ""
  },
  "docs.content.guide.store-management.b0.text": {
    "translation": ""
  },
  "docs.content.guide.store-management.b1.i0.term": {
    "translation": ""
  },
  "docs.content.guide.store-management.b1.i0.def": {
    "translation": ""
  },
  "docs.content.guide.store-management.b1.i1.term": {
    "translation": ""
  },
  "docs.content.guide.store-management.b1.i1.def": {
    "translation": ""
  },
  "docs.content.guide.order-report-service.title": {
    "translation": ""
  },
  "docs.content.guide.order-report-service.b0.text": {
    "translation": ""
  },
  "docs.content.guide.order-report-service.b1.i0.term": {
    "translation": ""
  },
  "docs.content.guide.order-report-service.b1.i0.def": {
    "translation": ""
  },
  "docs.content.guide.order-report-service.b1.i1.term": {
    "translation": ""
  },
  "docs.content.guide.order-report-service.b1.i1.def": {
    "translation": ""
  },
  "docs.content.guide.order-report-service.b1.i2.term": {
    "translation": ""
  },
  "docs.content.guide.order-report-service.b1.i2.def": {
    "translation": ""
  },
  "docs.content.guide.terminology.title": {
    "translation": ""
  },
  "docs.content.guide.terminology.b0.i0.term": {
    "translation": ""
  },
  "docs.content.guide.terminology.b0.i0.def": {
    "translation": ""
  },
  "docs.content.guide.terminology.b0.i1.term": {
    "translation": ""
  },
  "docs.content.guide.terminology.b0.i1.def": {
    "translation": ""
  },
  "docs.content.guide.terminology.b0.i2.term": {
    "translation": ""
  },
  "docs.content.guide.terminology.b0.i2.def": {
    "translation": ""
  },
  "docs.content.guide.terminology.b0.i3.term": {
    "translation": ""
  },
  "docs.content.guide.terminology.b0.i3.def": {
    "translation": ""
  },
  "docs.content.guide.terminology.b0.i4.term": {
    "translation": ""
  },
  "docs.content.guide.terminology.b0.i4.def": {
    "translation": ""
  },
  "docs.content.guide.terminology.b0.i5.term": {
    "translation": ""
  },
  "docs.content.guide.terminology.b0.i5.def": {
    "translation": ""
  },
  "docs.content.guide.terminology.b0.i6.term": {
    "translation": ""
  },
  "docs.content.guide.terminology.b0.i6.def": {
    "translation": ""
  },
  "docs.content.guide.terminology.b0.i7.term": {
    "translation": ""
  },
  "docs.content.guide.terminology.b0.i7.def": {
    "translation": ""
  },
  "docs.content.guide.faq.title": {
    "translation": ""
  },
  "docs.content.guide.faq.b0.text": {
    "translation": ""
  },
  "docs.content.guide.faq.b1.text": {
    "translation": ""
  },
  "docs.content.guide.faq.b2.text": {
    "translation": ""
  },
  "docs.content.guide.faq.b3.text": {
    "translation": ""
  },
  "docs.content.guide.faq.b4.text": {
    "translation": ""
  },
  "docs.content.guide.faq.b5.text": {
    "translation": ""
  },
  "docs.content.guide.faq.b6.text": {
    "translation": ""
  },
  "docs.content.guide.faq.b7.text": {
    "translation": ""
  },
  "docs.content.guide.faq.b8.text": {
    "translation": ""
  },
  "docs.content.guide.faq.b9.text": {
    "translation": ""
  },
  "docs.content.guide.post-production.title": {
    "translation": ""
  },
  "docs.content.guide.post-production.b0.text": {
    "translation": ""
  },
  "docs.content.guide.post-production.b1.i0.body": {
    "translation": ""
  },
  "docs.content.guide.post-production.b1.i1.body": {
    "translation": ""
  },
  "docs.content.guide.post-production.b1.i2.body": {
    "translation": ""
  },
  "docs.content.guide.post-production.b1.i3.body": {
    "translation": ""
  },
  "docs.content.guide.post-production.b2.text": {
    "translation": ""
  },
  "docs.content.guide.post-production.b3.i0": {
    "translation": ""
  },
  "docs.content.guide.post-production.b3.i1": {
    "translation": ""
  },
  "docs.content.guide.post-production.b3.i2": {
    "translation": ""
  },
  "docs.content.guide.post-production.b3.i3": {
    "translation": ""
  }
}
